class LoadMore extends HTMLElement {
    constructor() {
        super();

        this.handleClick = this.handleClick.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.parentContainer = this.closest("[data-load-more-container]");
        this.targetContainer = this.parentContainer.querySelector("[data-load-more-target-container]");
        this.currentPage = this.dataset.currentPage;
        this.nextUrl = this.dataset.nextUrl;
        this.totalPages = this.dataset.totalPages;
    }

    connectedCallback() {
        document.addEventListener("custom:load:products", () => {
            this.updateData();
        })
        this.updateData();
        // this.addEventListener("click", this.handleClick);
        // this.targetContainer.addEventListener("scroll", this.handleScroll);
    }

    handleScroll() {
        const inView = this.isScrolledToEnd(this.targetContainer);

        if (inView) this.updateData();
    }

    isScrolledToEnd(container) { return container.scrollTop + container.clientHeight >= container.scrollHeight; }

    disconnectedCallback() {
        this.removeEventListener("click", this.handleClick);
        this.targetContainer.removeEventListener("scroll", this.handleScroll);
    }

    handleClick(event) {
        if (event.target.closest("[data-load-more-button]")) {
            this.updateData()
        }
    }

    updateData() {
        const nextPage = +this.currentPage + 1;
        const url = this.nextUrl.replace(/page=[0-9]+/, 'page=' + nextPage);
        console.log(url);
        
        fetch(url)
            .then(response => response.text())
            .then((data) => {
                const dataHtml = new DOMParser().parseFromString(data, "text/html");
                const selector = this.parentContainer.dataset.idLoad ? `[data-id-load='${this.parentContainer.dataset.idLoad}'] [data-load-more-target-container]` : "[data-load-more-target-container]";
                const loadedContent = dataHtml.querySelector(selector);
                
                if (loadedContent) {
                    this.targetContainer.innerHTML += loadedContent.innerHTML;
                }
            })
            .catch((error) => {
                console.error(error)
            })
            .finally(() => {
                this.currentPage = +this.currentPage + 1;

                if (+this.currentPage >= +this.totalPages) {
                    this.classList.add("hidden");
                    console.log(this.targetContainer.querySelectorAll("[data-item-button]").length);

                    this.targetContainer.removeEventListener("scroll", this.handleScroll);
                }
            })
    }
}

if (!window.customElements.get("load-more")) {
    window.customElements.define("load-more", LoadMore);
}